/**
 * `useConnectivity` — subscribe to backend reachability (see `providers/connectivity.ts`).
 *
 * Returns `true` when the backend is reachable and `false` when it is not (the bottom-left
 * status indicator then reads "Web Services Unreachable" and the app runs from its local
 * IndexedDB cache). Backed by `useSyncExternalStore` over the connectivity singleton, so any
 * component that needs the live state re-renders on change without prop-drilling.
 */

import { useSyncExternalStore } from 'react';
import { connectivity } from '@/providers/connectivity';

export function useConnectivity(): boolean {
  return useSyncExternalStore(
    connectivity.subscribe,
    connectivity.getSnapshot,
    () => true, // server/SSR snapshot — assume reachable
  );
}
